import moment from "moment";
import { isOldAlicUlPolicy } from "./isOldAlicUlPolicy";

export const isPolicyInGrace = (policy) => {
  const { modalPremiumAmountTotal, premiumDueDate, status, product } =
    policy || {};
  const lowerCaseStatus = status?.toLowerCase();

  if (isOldAlicUlPolicy(policy)) {
    if (
      lowerCaseStatus === "reinstated" ||
      lowerCaseStatus === "active" ||
      lowerCaseStatus === ""
    ) {
      const costOfInsuranceDueDate =
        policy?.costOfInsurance?.costOfInsuranceDueDate;
      if (!costOfInsuranceDueDate) {
        return policy?.graceFlag?.toLowerCase() === "y";
      } else {
        const dueDate = moment(costOfInsuranceDueDate);
        return dueDate.isBefore(moment());
      }
    } else {
      return false;
    }
  }

  return (
    parseFloat(modalPremiumAmountTotal) > 0 &&
    moment(premiumDueDate).isBefore(moment()) &&
    !["lapsed", "reducedpaidup", "paid-up"].includes(lowerCaseStatus)
  );
};
